import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ViewChild } from '@angular/core';
import { DetailComparisonService } from '../services/detail-comparison.service';
import { DetailCompareDetails, DetailCompareGroup, Action, DetailCompareHeader } from '../objects/CompareObject';
import { WorkspaceService } from '../services/workspace.service';
import { Globals } from '../objects/Globals';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';

@Component({
  selector: 'app-comparison',
  templateUrl: './comparison.component.html',
  styleUrls: ['./comparison.component.css']
})
export class ComparisonComponent implements OnInit, OnDestroy {

  @ViewChild(ContextMenuComponent) public basicMenu: ContextMenuComponent;

  loaderConfig: any;
  step = 0;
  title: string;
  originalCompareObject: DetailCompareDetails;
  compareObject: DetailCompareDetails;
  isBusy: boolean = false;
  componentId: string;
  columnsCount: number = 0;
  paramList:any = [];
  columns: any = [];
  hiddenHeaders: any = [];

  @Input() set setComponentId(id: string){
    this.componentId = id
    this.getComparisonInfo();
  }

  @Input() set triggerAction(action: Action){
    if (action){
      this.compareAction(action.ActionName);
    }
  }

  @Output() compareActions = new EventEmitter<Action[]>();
  @Output() loadingPopup = new EventEmitter<boolean>();
  @Output() hidePopup = new EventEmitter<boolean>();

  constructor(
    private detailComparisonService: DetailComparisonService, 
    private globals:Globals, 
    private workspaceService: WorkspaceService, 
    private workflowReturnService: WorkflowReturnService,
    private contextMenuService: ContextMenuService) { }

  ngOnInit() {
    document.querySelectorAll("body").item(0).style.position = "relative";
  }

  ngOnDestroy(){
    document.querySelectorAll("body").item(0).style.position = "initial";
  }

  getComparisonInfo(){  
    this.isBusy = true;
    this.detailComparisonService.getDetailComparisonInfo(this.componentId).subscribe(result => {
      this.isBusy = false;
      this.originalCompareObject = JSON.parse(result);
      this.columns = [];
      if (this.originalCompareObject.Actions){
        this.compareActions.emit(this.originalCompareObject.Actions);  
      }
      
      this.compareObject = JSON.parse(result);
      this.formatCompareObject();
      this.pushColumnsDropdown();
    })
  }

  pushColumnsDropdown(){
    this.originalCompareObject.Headers.forEach(element => {
      let d = document.createElement('div');
      d.innerHTML = element.HeaderDisplay;
      
      var displayColm = {Order: element.Order, Name: element.Name, HeaderDisplay: d.innerText, OriginalDisplay: element.HeaderDisplay, isChecked: true}
      this.columns.push(displayColm);
    });
  }

  formatCompareObject(){
    this.sortHeader();
    this.compareObject.Headers = this.compareObject.Headers.slice(0, 4);;

    var i = 0;
    
    this.compareObject.Headers.forEach(header => {
      if (this.compareObject.Headers.length + 1 == 5){
        this.columnsCount = 5;
      }
      else{
        this.columnsCount = 12 / (this.compareObject.Headers.length + 1);
      }
    })
  }

  setStep(index: number, groupName: string) {
    this.step = index;
    this.isBusy = false;
    if (!this.compareObject.Groups.find(x => x.Name == groupName).Data){
      this.detailComparisonService.getDetailComparisonGroup(this.componentId, groupName).subscribe(result => {
        this.compareObject.Groups.find(x => x.Name == groupName).Data = JSON.parse(result);
        //console.log(this.compareObject);
      });
    }
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  getVisiblePrevious(header: DetailCompareHeader, first: boolean){
    if (first && this.compareObject.Headers.length > 3){
      var index = this.originalCompareObject.Headers.findIndex(x => x.Name == header.Name);
      if (index > -1 && this.originalCompareObject.Headers[index - 1]){
        return true;
      }
      else{
        return false;
      }
    }
    else{
      return false;
    }
  }

  getVisibleNext(header: DetailCompareHeader, last: boolean){
    if (last && this.compareObject.Headers.length > 3){
      var index = this.originalCompareObject.Headers.findIndex(x => x.Name == header.Name);
      if (index > -1 && this.originalCompareObject.Headers[index +1]){
        return true;
      }
      else{
        return false;
      }
    }
    else{
      return false;
    }
  }
  
  nextItem(){
    var lastName = this.compareObject.Headers[this.compareObject.Headers.length - 1].Name;

    var lastIndex = this.originalCompareObject.Headers.findIndex(x => x.Name == lastName);

    if (this.originalCompareObject.Headers[lastIndex + 1]){
      this.compareObject.Headers.shift();
      this.compareObject.Headers.push(this.originalCompareObject.Headers[lastIndex + 1]);
    }  
  }

  previousItem(){
    var firstName = this.compareObject.Headers[0].Name;

    var firstIndex = this.originalCompareObject.Headers.findIndex(x => x.Name == firstName);

    if (this.originalCompareObject.Headers[firstIndex - 1]){
      this.compareObject.Headers.splice(-1,1);
      this.compareObject.Headers.unshift(this.originalCompareObject.Headers[firstIndex - 1]);
    } 
  }

  onValueChange(groupName: string, propertyDisplay: string, headerName: string, value: string){
    var param:any;

    // construct object to prepare for workflow parameter => it is a list of headers, which has a list of all its changed properties 
    if (this.paramList.find(x => x.name == headerName)){
      var existingParam = this.paramList.find(x => x.name == headerName);

      if (this.originalCompareObject.Groups.find(x => x.Name == groupName).Type == "SUBDOC"){
        param = {name: propertyDisplay, value: value, group: groupName}
      }
      else{
        param = { name: propertyDisplay, value: value };
      }

      var exists = existingParam.value.findIndex(z => z.name == propertyDisplay);

      if (exists > -1){
        existingParam.value.splice(exists, 1, param);
      }
      else{
        existingParam.value.push(param);
      }
    }
    else{
      var headerArray = [];
      var header:any;
      header = { name: "DocumentInstanceId", value: headerName}; // this is the identifier for each header, headerName == header id

      if (this.originalCompareObject.Groups.find(x => x.Name == groupName).Type == "SUBDOC"){
        param = {name: propertyDisplay, value: value, group: groupName}
      }
      else{
        param = { name: propertyDisplay, value: value };
      }

      headerArray.push(header);
      headerArray.push(param);

      this.paramList.push({ name: headerName, value: headerArray}); // so param list will contains all the list of header arrays
    }

    //console.log(headerArray);
    //console.log(this.paramList);

    this.detailComparisonService.detailComparisonUpdateValue(this.componentId, groupName, headerName, param).subscribe(result => {
      console.log(result);
    })
  }

  compareAction(actionName: string){
    this.loadingPopup.emit(true);
    var arr = [];
    this.originalCompareObject.Headers.forEach(header => {
      if (!header.Name.startsWith("#")){
        arr.push({name: 'Name', value: header.Name});  
      }
    })
    this.detailComparisonService.detailComparisonAction(this.componentId, actionName, arr).subscribe(result => {
      this.loadingPopup.emit(false);
      if (result) {
        var wf = JSON.parse(result);
        this.workflowReturnService.handleWorkflowReturn(wf);

        switch(wf.RefreshType){
          case "self": this.getComparisonInfo(); break;
          case "parent":
            this.isBusy = true;
            this.getComparisonInfo();
            this.getEPICParent(false, wf.ReturnType);
            break;
          case "all":
            this.getComparisonInfo();
            this.getEPICParent(true, wf.ReturnType);
          break;
        }
      }
    }, error => {
      this.loadingPopup.emit(false);
    })
  }

  


  getEPICParent(findAllParent:boolean, returnType:number){
    if (findAllParent){
      this.workspaceService.getAllParentsEPICId(this.componentId).subscribe(result => {
        this.handlePopup(returnType);
        if (result){
          let array = JSON.parse(result);
          array.forEach(id => {
            this.workspaceService.setParentId(id);
          });
        }
      }, error => {
        this.handlePopup(returnType);
      })
    }
    else{
      this.workspaceService.getParentEPICId(this.componentId).subscribe(result => {
        this.workspaceService.setParentId(result);
        this.handlePopup(returnType);
      }, error => {
        this.handlePopup(returnType);
      })
    }
  }

  handlePopup(returnType, isPreview: boolean = false){
    if (returnType == 4){
      this.hidePopup.emit(true);
    }
  }

  onSelectionChange(event){
    this.loadingPopup.emit(true);
    this.detailComparisonService.getFileCompareObject(this.componentId, this.originalCompareObject.CompareDefinition, encodeURIComponent(event.SelectionValue), this.originalCompareObject.ComparingIds).subscribe(result => {
      if (result){
        var command = JSON.parse(result);
        this.workflowReturnService.handleWorkflowReturn(JSON.parse(result));

        switch(command.RefreshType){
          case "self": 
            this.getComparisonInfo();
          break;
        }
      }
      this.loadingPopup.emit(false);
    }, error => {
      this.loadingPopup.emit(false);
    })
  }

  drop(event){
    if (event){
      if (event.value){
        if (event.value.Order){
          var header = this.compareObject.Headers.find(x => x.Name == event.value.Name); // drag element
          if (header){
            var originalOrder = header.Order;
            if (this.compareObject.Headers[event.dropIndex - 1]){ // target element
              var newOrder = this.compareObject.Headers[event.dropIndex - 1].Order;
              this.compareObject.Headers[event.dropIndex - 1].Order = originalOrder;
              
              if (this.originalCompareObject.Headers.find(x => x.Name == this.compareObject.Headers[event.dropIndex - 1].Name)){ // find target element in original headers
                this.originalCompareObject.Headers.find(x => x.Name == this.compareObject.Headers[event.dropIndex - 1].Name).Order = originalOrder;
              }
              header.Order = newOrder;
              this.originalCompareObject.Headers.find(x => x.Name == event.value.Name).Order = newOrder;
            }

            this.sortHeader();
            this.sortOriginalHeader();
            this.originalCompareObject = Object.assign({}, this.originalCompareObject);
            this.compareObject = Object.assign({}, this.compareObject);
          }
        }
      }
    }
  }

  sortHeader(){
    this.compareObject.Headers = this.compareObject.Headers.sort((a:DetailCompareHeader,b:DetailCompareHeader) => { 
      if(a.Order > b.Order){
        return 1;
      }else if(a.Order < b.Order){
        return -1;
      }else{
        return 0;
      }
     });
  }

  sortOriginalHeader(){
    this.originalCompareObject.Headers = this.originalCompareObject.Headers.sort((a:DetailCompareHeader,b:DetailCompareHeader) => { 
      if(a.Order > b.Order){
        return 1;
      }else if(a.Order < b.Order){
        return -1;
      }else{
        return 0;
      }
     });
  }

  public onContextMenu($event): void {
    if($event.button == 0){
      this.contextMenuService.show.next({
        anchorElement: $event.target,
        contextMenu: this.basicMenu,
        event: $event,
        item: ''
      });
    }
    $event.preventDefault();
    $event.stopPropagation();
  }

  onChange(event){
    if (!event.isChecked){ // hide
      var visible = true;
      var header = this.compareObject.Headers.find(x => x.Name == event.Name); // find in visible headers
      if (!header){
        header = this.originalCompareObject.Headers.find(x => x.Name == event.Name); // find in original headers
        visible = false;
      }

      header["isVisible"] = visible; // this is to know where its from, either from the visible headers, or the original list
      this.hiddenHeaders.push(header);
      if (visible){
        if (this.compareObject.Headers.length == 4){ // only more than 4, push one either from the back or from the front of original to visible headers
          var nextHeader = this.originalCompareObject.Headers[this.originalCompareObject.Headers.findIndex(x => x.Name == this.compareObject.Headers[this.compareObject.Headers.length - 1].Name) + 1];
          if (!nextHeader){
            nextHeader = this.originalCompareObject.Headers[this.originalCompareObject.Headers.findIndex(x => x.Name == this.compareObject.Headers[0].Name) - 1];
          }

          if (nextHeader){
            this.compareObject.Headers.push(nextHeader);
          }
        }
        
        this.compareObject.Headers.splice(this.compareObject.Headers.findIndex(x => x.Name == event.Name), 1);
        this.originalCompareObject.Headers.splice(this.originalCompareObject.Headers.findIndex(x => x.Name == event.Name), 1);
      }
      else{
        this.originalCompareObject.Headers.splice(this.originalCompareObject.Headers.findIndex(x => x.Name == event.Name), 1);
      }
    }
    else{ //show
      var newObj = {
        Order: event.Order,
        Name: event.Name,
        HeaderDisplay: event.OriginalDisplay
      }
      var isVisible = this.hiddenHeaders.find(x => x.Name == event.Name).isVisible;
      this.hiddenHeaders.splice(this.hiddenHeaders.findIndex(x => x.Name == event.Name), 1);

      if (isVisible){ // if from visible headers
        this.compareObject.Headers.push(newObj);
      }
      else{
        if (this.compareObject.Headers.findIndex(x => x.Name == event.Name) == -1 && this.compareObject.Headers.length < 4){
          this.compareObject.Headers.push(newObj);
        }
      }

      var g = this.originalCompareObject.Headers.find(x => x.Name == newObj.Name);

      if (!g){
        this.originalCompareObject.Headers.push(newObj);
      }
    }

    this.formatCompareObject();
    this.sortOriginalHeader();
    this.originalCompareObject = Object.assign({}, this.originalCompareObject);
    this.compareObject = Object.assign({}, this.compareObject);
  }
}
